import { render, staticRenderFns } from "./Pass.vue?vue&type=template&id=006c6e06&scoped=true"
import script from "./Pass.vue?vue&type=script&lang=js"
export * from "./Pass.vue?vue&type=script&lang=js"
import style0 from "./Pass.vue?vue&type=style&index=0&id=006c6e06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006c6e06",
  null
  
)

export default component.exports